export const accordionItemTestIds = {
  accordionItemTestId: 'accordion-item',
  accordionActivatorButtonTestId: 'accordion-item-activation-button',
  accordionItemTitleTestId: 'accordion-item-title',
  accordionItemContentTestId: 'accordion-item-content',
};
